import { z } from "zod";

export const contactFormSchema = z.object({
  name: z
    .string({ required_error: "O nome é obrigatório" })
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
  email: z
    .string({ required_error: "O email é obrigatório" })
    .email("Email inválido"),
  subject: z.string({ required_error: "O assunto é obrigatório" }),
  message: z
    .string({ required_error: "O comentário é obrigatório" })
    .min(3, "A mensagem deve ter no mínimo 3 caracteres"),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
